let labels = {}
labels.Securities = `
    Fixed income securities are a type of debt instrument
    which typically offers an investor regular (fixed) interest payments,
    and the return of their principal upon maturity.
    Select the type of bond you want to search for.
`

labels.Issuer = `
    Enter a full name to search for offerings by issuer.
`

labels.Cusip = `
    To search for offerings by CUSIP, enter a full or partial (5 character minimum)
    CUSIP number.  For example, entering "36966" will return all offerings with a CUSIP
    beginning with 36966.  To conduct a multi-CUSIP search, enter full CUSIP numbers
    separated by commas.
`


labels.CorpSector = `
    Search results will only show offerings within the selected sector(s).
`

labels.CorpFeatures = `
    Convertible bonds give the bondholder the option to convert their bonds to
    a predetermined number of shares in the issuing company's common stock.
`

labels.CorpDebtRanks =`
    Debt ranking is the order repayment is made to bondholders in the event
    of a company's bankruptcy or liquidation. Secured/Senior bonds rank highest
    in safety and repayment order over subordinated/junior debt.
`

labels.CorpMarketTypes = `
    Fixed income securities are initially created and sold to investors on
    the new issue (primary) market.  The secondary market is where investors buy
    and sell securities that have been previously owned by other investors.
    Select whether you want to search for new issue or secondary market bonds.
`

labels.CorpSymbol = `
    View debt offerings from publicly traded companies via ticker symbol search.
`

labels.MuniStates = `
    Search results will only show offerings within the selected state(s).
`

labels.MuniCategories = `
    Municipal bonds are typically classified into two main categories:
    <ol>
    <li>General Obligation: bonds are secured by the taxing authority of the issuing state or municipality </li>
    <li>Revenue: bonds are backed by the income generated by the public project the bond is funding </li>
    </ol>
`

labels.MuniTaxTreatments = `
    Select any special tax considerations for your municipal bond search.
    Tax-exempt bonds do not tax the interest earned on bonds purchased by residents
    of the issuing state and may also be exempt from local taxes.
    Taxable bonds are subject to state and local taxes.
`

labels.MuniPurposes = `
    The general purpose or project category the issuer is financing
`

labels.MuniEnvironmentals = `
    Municipal bonds which allocate proceeds to fund environmentally-sustainable
    projects. Make a selection to view results within the chosen environmental category.
`

labels.MuniDeminimis = `
    The De Minimis rule states that Capital Gains Tax must be paid on a bond Purchased at a discount 
    of the Face Value in excess of a quarter point per year between the time of Acquisition and Maturity. 
    If the Acquisition Price is above the De Minimis Threshold, then the bondholder will be entitled to
    preferential Tax treatment on the Appreciation to Par. 
    If the Acquisition Price is below the De Minimis Threshold, then all Appreciation to Par is subject 
    to ordinary tax rates. 
    The tax treatment to existing client holdings is determined by the Acquisition Price and will not change
    during the life of the bond if held to Maturity. However, as Market Prices change, the different tax treatment 
    to a new owner may materially impact the Market Price and/or Marketability of the bond if a sale is anticipated.
`
    
labels.MuniInsured = `
    Insured municipal bonds provide investors with additional security that the bond's
    interest and principal payments will be made in the event of an issuer default.
    To search for Insured bonds, click the checkbox.
`

labels.CdBlueSky = `
    This filter ensures your search results do not contain any brokered CD offers which have
    Blue Sky restrictions in your state of residence.
`

labels.BlueSkyRestriction = `
    What are Blue Sky restrictions? Individual states have a set of securities laws,
    commonly referred to as Blue Sky Laws, which govern the sale of securities in their state.
    These laws, which vary by state, are established to protect investors from securities fraud.
    CD offerings from issuing banks that do not comply with a state's Blue Sky Laws
    are restricted from sale to residents of that state.
`

labels.CdFdic = `
    Search results will only display offerings from the banking institution aligned
    the FDIC certificate number input.
`

labels.TreasuryTypes = `
    Search results will only display offerings from the selected treasury type(s).
    T-Bills feature shorter-term maturities ranging from 4-52 weeks.
    T-Notes feature medium-term maturities ranging from 2-10 years.
    T-Bonds feature longer-term maturities of 10 years or greater.
`

labels.AgencyTypes = `
    Search results will only display offerings from the selected issuer(s).
`

labels.MarketType = `
    Fixed income securities are initially created and sold to investors
    on the new issue (primary) market.
    The secondary market is where investors buy and sell securities
    that have been previously owned by other investors.
    Select whether you want to search for new issue or secondary market bonds.
`

labels.Maturity = `
    Maturity date is the date the principal amount of
    a security becomes due and payable to the investor.
    Select your preferred maturity date range using the following criteria:
    <ul>
    <li>Days: Enter the number of days in the future, followed by "d" (e.g., "365d" for one year)</li>
    <li>Months: Enter the number of months in the future, followed by "m" (e.g., "24m" for two years)</li>
    <li>Years: Enter the number of years in the future, followed by "y" (e.g., "3y" for 3 years)</li>
    <li>The following formats are also acceptable: "mm/yy" or "mm/yyyy" (e.g., January 2028 could be entered as "01/28")</li>
    </ul>
`

labels.Yield = `
    The yield-to-worst metric is used to evaluate
    the lowest (worst-case scenario) yield an investor could experience
    &mdash; with the assumption the issuer does not default.
    Select your range for yield-to-worst.
`

labels.YieldToMaturity = `
    Yield to maturity represents the annualized rate of return for
    the bond if held to the maturity date.
`

labels.Coupon = `
    A bond’s coupon is its annual interest rate, which is expressed as a percentage
    of the bond’s face value. For example: a $1,000 bond with a 5% coupon would
    pay $50 a year, typically in semi-annual payments.
`

labels.CouponFrequencies = `
    Refine your results to bonds with specific coupon payment frequencies.
`

labels.CouponPayMonths = `
    Select the month(s) you wish to receive your coupon payments.
`

labels.CouponFeatures = `
    Most bonds feature predetermined fixed-rate coupons that remain static over
    the life of the bond.  Alternatively, some bonds have variable or floating rate structures
    linked to a reference benchmark rate which adjusts over the life of the bond – or even a step-up
    coupon structure which can feature increasing rates as the bond nears maturity.
    Lastly, we have zero-coupon bonds which do not pay interest over the life of the bond,
    but instead are issued at a discount and pay full face value upon maturity.
`

labels.Rating = `
    Credit ratings are designations provided by ratings agencies (like Moody's and S&P)
    to help investors assess the relative credit quality of individual bonds.
    A rating of BBB- or higher by S&P or Baa3 or higher by Moody's is considered investment-grade.
    Ratings below that tier are considered speculative (high-yield).
    Select the minimum and/or maximum credit rating for your bond search.
    By default, searches will return results that match the selections made in either the Moody’s or S&P credit ratings dropdowns.
    The checkbox labeled "Results can match Moody’s or S&P ratings selection" can be unselected to only return results
    that match the selections made in both the Moody’s and S&P credit ratings dropdowns.
`

labels.Quantity = `
    Search results will only contain offers from dealers with enough bonds
    to meet to your requested quantity criteria.
    Select the minimum and/or maximum number of bonds you want to trade.
`

labels.Price = `
    Par value for bonds is typically set at 100,
    meaning 100% of the bond’s face value of $1,000.
    As an example, entering a maximum price value of “98”,
    will return bonds trading at up to 98% of their face value, or $980.
    Select your preferred price range, expressed as a percentage of the bond’s face value.
`

labels.Category = `
    Municipal bonds are classified as either of the following:
    <ul>
    <li>General Obligation Bonds:  Secured by the full faith, credit, and taxing power of the issuer.</li>
    <li>Revenue Bonds: Backed by the operational revenue from the projects financed by the bonds.</li>
    </ul>
    Select the type of municipal bond you would like to search for.
`

labels.TaxTreatment = `
    Municipal bonds may be exempt from federal, state, and local taxes
    if purchased from the state or city in which you reside.
    However, some municipal bonds may be subject to federal income tax or AMT (Alternative Minimum Tax).
    Select the tax considerations for your search.
`

labels.CallFeatures = `
    A callable bond gives the issuer the right to redeem (call) the bond prior to maturity.
`

labels.PutFeatures = `
    A puttable bond gives the bondholder the right to require the issuer redeem (repurchase)
    the bond prior to maturity.
`

labels.OtherFeatures = `
    Search results will display offerings aligned with the selected criteria.
`

labels.NextCall = `
    The call date is the date which an issuer has the right to redeem (call) a bond prior to maturity.
    The "Next Call" search feature allows you to refine search results for callable bonds
    with minimum or maximum call date timeframes. For example, if you wanted to ensure the bonds in
    your search results will not encounter a call date for the next 10 years, you could enter "10y"
    within the "Next call min" field.
    Select your preferred next call date range using the following criteria:
    <ul>
    <li>Days: Enter the number of days in the future, followed by "d" (e.g., "365d" for one year)</li>
    <li>Months: Enter the number of months in the future, followed by "m" (e.g., "24m" for two years)</li>
    <li>Years: Enter the number of years in the future, followed by "y" (e.g., "3y" for 3 years)</li>
    <li>The following formats are also acceptable: "mm/yy" or "mm/yyyy" (e.g., January 2028 could be entered as "01/28")</li>
    </ul>
`
export default labels


// WEBPACK FOOTER //
// ./src/twd/fields/labels.js